/**
 * vl-swatch-click.js
 * Universal color swatch image switching on collection / search pages.
 * Fires whenever any radio input inside a product-card changes.
 * Switches the card's slideshow to the slide matching the variant's media ID.
 */
(function () {
  'use strict';

  /**
   * Switch the product card slideshow to show the slide for mediaId.
   */
  function switchCardImage(productCard, mediaId) {
    if (!mediaId) return false;

    // Use the built-in previewVariant method — it handles the slideshow internally.
    if (typeof productCard.previewVariant === 'function') {
      if (productCard.resetVariant && typeof productCard.resetVariant.cancel === 'function') {
        productCard.resetVariant.cancel();
      }
      productCard.previewVariant(mediaId);
      return true;
    }

    // Fallback: find any slideshow and directly select the matching slide.
    var slides = productCard.querySelectorAll('[slide-id]');
    var matched = false;
    slides.forEach(function (slide) {
      var isMatch = slide.getAttribute('slide-id') === mediaId;
      slide.hidden = !isMatch;
      if (isMatch) matched = true;
    });
    return matched;
  }

  /**
   * Update all product-card links to include the selected variant ID.
   */
  function updateCardLink(productCard, variantId) {
    if (!variantId) return;
    productCard.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', variantId);
        link.href = url.toString();
      } catch (e) {}
    });
  }

  /**
   * Handle every radio input change inside a product-card.
   */
  function onInputChange(event) {
    var input = event.target;
    if (!input || input.type !== 'radio') return;

    // Must be inside a product-card custom element.
    var productCard = input.closest('product-card');
    if (!productCard) return;

    // Read the media ID — first from the input, then from the wrapping label.
    var mediaId = input.dataset.optionMediaId || '';
    if (!mediaId) {
      var label = input.closest('label');
      if (label) mediaId = label.dataset.mediaId || '';
    }

    // Read the variant ID.
    var variantId =
      input.dataset.variantId ||
      input.dataset.firstAvailableOrFirstVariantId ||
      '';

    switchCardImage(productCard, mediaId);
    updateCardLink(productCard, variantId);
  }

  // Use capture phase so we receive events before any stopPropagation.
  document.addEventListener('change', onInputChange, true);
})();
